<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label>Material</label>
                  <input
                    type="text"
                    id="material"
                    class="form-control"
                    v-model="material.nome"
                  />
                </div>
                <div class="col-md-6">
                  <label>Código de barras</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="material.codigo"
                  />
                </div>
                <div class="col-md-2 form-group">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      autocomplete="new-password"
                      v-model="material.dispensavel"
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch3"
                    />
                    <label class="custom-control-label" for="customSwitch3"
                      ><b
                        :class="
                          material.dispensavel
                            ? 'text-primary'
                            : 'text-secondary'
                        "
                        >Dispensável</b
                      ></label
                    >
                  </div>
                </div>
                <div class="col-md-2 form-group">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      autocomplete="new-password"
                      v-model="material.controlado"
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch1"
                    />
                    <label class="custom-control-label" for="customSwitch1"
                      ><b
                        :class="
                          material.controlado
                            ? 'text-primary'
                            : 'text-secondary'
                        "
                        >Necessita autorização</b
                      ></label
                    >
                  </div>
                </div>
                <div class="col-md-2 form-group">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      autocomplete="new-password"
                      v-model="material.portaria"
                      placeholder=""
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch2"
                    />
                    <label class="custom-control-label" for="customSwitch2"
                      ><b
                        :class="
                          material.portaria ? 'text-primary' : 'text-secondary'
                        "
                        >Portaria 344/98</b
                      ></label
                    >
                  </div>
                </div>
                <div class="col-md-2">
                  <label>Período dispensável</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="material.periodo_dispensavel"
                  />
                </div>
                <div class="col-md-2">
                  <label>Estoque mínimo</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="material.estoque_minimo"
                  />
                </div>
                <div class="col-md-4">
                  <label>Unidade dispensada</label>
                  <v-select
                    :options="unidadeMateriais"
                    :reduce="(unidadeMateriais) => unidadeMateriais.id"
                    :label="'label_unidade'"
                    v-model="material.unidade_dispensada"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Tipo Receita</label>
                  <v-select
                    :options="tipo_receitas"
                    :searchble="true"
                    :reduce="(tipo_receitas) => tipo_receitas.id"
                    :label="'label_tipo_receita'"
                    v-model="material.tipo_receita_id"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Grupo</label>
                  <v-select
                    :options="grupos"
                    :reduce="(grupos) => grupos.id"
                    :label="'nome'"
                    v-model="material.grupo_id"
                    @input="getSubGrupos()"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Sub Grupo</label>
                  <v-select
                    :options="sub_grupos"
                    :reduce="(sub_grupos) => sub_grupos.id"
                    :label="'nome'"
                    v-model="material.subgrupo_id"
                    :disabled="sub_grupos.length ? false : true"
                    @input="getFamilias()"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Família</label>
                  <v-select
                    :options="familias"
                    :reduce="(familias) => familias.id"
                    :label="'nome'"
                    v-model="material.familia_id"
                    :disabled="familias.length ? false : true"
                    @input="getGrupos()"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Aba</label>
                  <v-select
                    :options="abas"
                    :reduce="(abas) => abas.id"
                    :label="'title'"
                    v-model="material.tab_id"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Tipos de Veículos</label>
                  <v-select
                    :options="tipo_veiculos"
                    :reduce="(tipo_veiculos) => tipo_veiculos.id"
                    :label="'nome'"
                    v-model="material.tipo_veiculo_ids"
                    multiple
                  ></v-select>
                </div>
                <div class="col-md-4" v-show="material.id">
                  <label>Grade</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="material.grade"
                  />
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/materiais" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left" />
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      material: {
        controlado: 0,
        portaria: 0,
        tipo_veiculo_ids: [],
      },
      tipo_receitas: [],
      grupos: [],
      sub_grupos: [],
      familias: [],
      abas: [],
      // fabricantes: [],
      // fornecedores: [],
      grupos: [],
      unidadeMateriais: [],
      tipo_veiculos: [],
    };
  },
  computed: {},
  methods: {
    getAbas() {
      const self = this;
      const api = self.$store.state.api + "tabs?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.abas = response.data.data;
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "materiais";

      self.$loading(true);

      if (self.material.id) {
        api += "/" + self.material.id;
        self.material._method = "PUT";
      }

      axios
        .post(api, self.material)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/materiais");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getMaterialTipoVeiculos(material_id) {
      const api =
        this.$store.state.api +
        "material_tipo_veiculos/by-material/" +
        material_id;

      axios
        .get(api)
        .then((response) => {
          this.material.tipo_veiculo_ids = response.data.tipos_veiculo.map(
            (tipo_veiculo) => tipo_veiculo.id
          );
        })
        .catch((error) => {
          console.error("Erro ao buscar Tipos de Veículos", error);
        });
    },
    _getMaterial: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "materiais/" + id + "?with[]=tipo_veiculos";

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.material = response.data.data[0];
          if (
            self.material.tipo_veiculo_ids &&
            self.material.tipo_veiculo_ids.length > 0
          ) {
            this.$set(
              this.material,
              "tipo_veiculo_ids",
              self.material.tipo_veiculo_ids.map(
                (tipo_veiculo_id) => tipo_veiculo_id.id
              )
            );
          } else {
            this.$set(this.material, "tipo_veiculo_ids", []);
          }
          self.loadSubGrupos();
          self.loadFamilias();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    get getMaterial() {
      return this._getMaterial;
    },
    set getMaterial(value) {
      this._getMaterial = value;
    },
    getTipoReceitas: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_receitas?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.tipo_receitas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoVeiculos: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_veiculos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.tipo_veiculos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getGrupos: function () {
      const self = this;
      const api = self.$store.state.api + "grupos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSubGrupos: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "sub_grupos?paginated=false&grupo_id=" +
        self.material.grupo_id;

      self.material.subgrupo_id = null;
      self.material.familia_id = null;
      self.sub_grupos = [];
      self.familias = [];

      axios
        .get(api)
        .then((response) => {
          self.sub_grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFamilias: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "familias?paginated=false&subgrupo_id=" +
        self.material.subgrupo_id;

      self.material.familia_id = null;
      self.familias = [];

      axios
        .get(api)
        .then((response) => {
          self.familias = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    loadSubGrupos: function () {
      const self = this;
      const api =
        self.$store.state.api + "sub_grupos?grupo_id=" + self.material.grupo_id;

      axios
        .get(api)
        .then((response) => {
          self.sub_grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    loadFamilias: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "familias?subgrupo_id=" +
        self.material.subgrupo_id;

      axios
        .get(api)
        .then((response) => {
          self.familias = response.data.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getFabricantes: function () {
      const self = this;
      const api = self.$store.state.api + "fabricantes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.fabricantes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFornecedores: function () {
      const self = this;
      const api = self.$store.state.api + "fornecedores?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.fornecedores = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidadeMateriais: function () {
      const self = this;
      const api = self.$store.state.api + "unidade_materiais?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidadeMateriais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getTipoReceitas();
    self.getGrupos();
    self.getAbas();
    self.getTipoVeiculos();
    // self.getFabricantes();
    // self.getFornecedores();
    self.getUnidadeMateriais();

    $("#material").focus();

    let id = self.$route.params.id;
    if (id) {
      self.getMaterial(id);
      setTimeout(() => {
        self.getMaterialTipoVeiculos(id);
      }, 1000);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>